module.exports = __webpack_public_path__ + "img/star_filled_icon.69cce9fa.svg";